module.exports = __webpack_public_path__ + "img/Volterres_80X30.8f249ace.png";